export default __webpack_public_path__ + "assets/icon-circle-document.ba123a2f.webp";